import React, { useMemo, useContext } from 'react'
import PropTypes from 'prop-types'
import { permissionTypes } from '@/enums/permissionTypes'
import { usePropertyReader } from '@/hooks/usePropertyReader'
import { PermissionSectionContext } from './permissionSectionContext'
import context from '@/context'
import { FormContext } from './formContext'
import { usePermissionsForInstitutions } from '@/hooks/usePermissionsForInstitutions'

const IndividualPermissionProvider = ({ individualPermission, children }) => {
  const [ relatedInstitutionIds ] = usePropertyReader(['relatedInstitutionIds'], 'originalData')
  const { isChangeItemId } = useContext(FormContext)
  const { individualEdit, individualReadOnly } = usePermissionsForInstitutions(relatedInstitutionIds, isChangeItemId)

  const permission = useMemo(() => {
    if (context.isReportApp()) return permissionTypes.enum.Edit

    if (individualEdit & individualPermission) {
      return permissionTypes.enum.Edit
    }
    if (individualReadOnly & individualPermission) {
      return permissionTypes.enum.ReadOnly
    }
    return permissionTypes.enum.None
  }, [individualEdit, individualPermission, individualReadOnly])

  return (permission === permissionTypes.enum.None ? null
    : <PermissionSectionContext.Provider value={permission !== permissionTypes.enum.Edit}>
      {children}
    </PermissionSectionContext.Provider>
  )
}

IndividualPermissionProvider.propTypes = {
  individualPermission: PropTypes.number,
  children: PropTypes.node.isRequired
}

export { IndividualPermissionProvider }



// WEBPACK FOOTER //
// ./src/components/changeRequests/individualPermissionProvider.js